(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"]) return;
  try {
    
  (() => {
    const status = document.querySelector('.contact__form [role="status"], .contact__form [role="alert"]');
    if (status) status.focus();

    document.querySelectorAll('.contact__form').forEach((form) => {
      form.addEventListener('submit', (event) => {
        const invalid = Array.from(form.querySelectorAll('[required]')).filter((field) => !field.checkValidity());
        form.querySelectorAll('[data-client-error]').forEach((el) => el.remove());
        form.querySelectorAll('[aria-invalid="true"]').forEach((el) => el.removeAttribute('aria-invalid'));
        if (!invalid.length) {
          form.querySelector('[type="submit"]')?.setAttribute('aria-busy', 'true');
          return;
        }
        event.preventDefault();
        invalid.forEach((field) => {
          const message = document.createElement('p');
          message.className = 'field__error';
          message.dataset.clientError = '';
          message.id = `${field.id}-client-error`;
          message.textContent = field.validationMessage;
          field.setAttribute('aria-invalid', 'true');
          field.setAttribute('aria-describedby', message.id);
          field.insertAdjacentElement('afterend', message);
        });
        invalid[0].focus();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterAccordion extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.media = window.matchMedia('(min-width: 900px)');
      this.sync = this.sync.bind(this);
      this.onSummaryClick = (event) => {
        if (this.media.matches) event.preventDefault();
      };
      this.details?.querySelector('summary')?.addEventListener('click', this.onSummaryClick);
      this.media.addEventListener('change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      this.media?.removeEventListener('change', this.sync);
    }

    sync() {
      if (!this.details) return;
      this.details.open = this.media.matches;
      const summary = this.details.querySelector('summary');
      if (this.media.matches) {
        summary?.setAttribute('tabindex', '-1');
      } else {
        summary?.removeAttribute('tabindex');
      }
    }
  }
  customElements.define('footer-accordion', FooterAccordion);

  } catch(e) { console.error(e); }
})();
})();
